import { render, staticRenderFns } from "./templateSayhiTwo.vue?vue&type=template&id=33f9ac3a&scoped=true"
import script from "./templateSayhiTwo.vue?vue&type=script&lang=js"
export * from "./templateSayhiTwo.vue?vue&type=script&lang=js"
import style0 from "./templateSayhiTwo.vue?vue&type=style&index=0&id=33f9ac3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9ac3a",
  null
  
)

export default component.exports